import { render, staticRenderFns } from "./team-member-mandatory-data.vue?vue&type=template&id=768123c5&scoped=true&"
import script from "./team-member-mandatory-data.vue?vue&type=script&lang=ts&"
export * from "./team-member-mandatory-data.vue?vue&type=script&lang=ts&"
import style0 from "./team-member-mandatory-data.vue?vue&type=style&index=0&id=768123c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768123c5",
  null
  
)

export default component.exports